import React from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-pitahaya via-pitahaya-dark to-pitahaya text-white py-3 px-4 shadow-md" data-id="element-16">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-center text-sm md:text-base font-medium" data-id="element-17">
        <motion.div animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="w-2.5 h-2.5 bg-gold-metallic rounded-full mr-3 flex-shrink-0 shadow-sm shadow-gold-metallic/50" data-id="element-18" />
        <p data-id="element-19">
          Registro abierto para el Webinar gratuito de Maximización de Capital |
          16 de Abril, 2026 — 7pm (Hora CDMX).
        </p>
      </div>
    </div>;
}